import api from "api/api";

export const createBranchQuery = async (data) =>
  await api.post("/settings/branch", data);

export const getBranchById = async (id) =>
  await api.get(`/settings/branch/${id}`);

export const updateBranchByIdQuery = async (id, data) =>
  await api.put(`/settings/branch/${id}`, data);

export const deleteBranchById = async (id) =>
  await api.delete(`/settings/branch/${id}`);

export const getAssignedBranchWithoutScopeQuery = async (id) =>
  await api.get(`/directory/staff/assigned-branches/?ids=${id}`);
